$(document).on('turbolinks:load', function() {
  return $(document).on('click', '.close-performed_activity-form', function(e) {
    $('#performed_activity-new').empty();
    return false;
  });
});
